<div class="modal-header header-modal">
  <h4 class="modal-title">AVISO IMPORTANTE</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Close click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-container *ngFor="let tm of textModals">
    <div class="d-flex flex-column justify-content-start align-items-start">
      <h3>{{tm.titulo}}</h3>
      <div class="text-justify" [innerHTML]="tm.texto">
      </div>
    </div>
  </ng-container>
</div>
<div class="modal-footer footer-modal">
  <button type="button" class="btn bg-transparent" (click)="activeModal.dismiss('Close click')" style="width: 100px">
    Volver
  </button>
  <button type="button" class="btn text-white" (click)="activeModal.close('Exito')" style="background: #e67e22;width: 100px">
    Confirmar
  </button>
</div>
